module.exports = require("./el.d.ts");